import { Component, cloneElement, Children } from "react";

import "./style.scss";

let id = 0;

class Select extends Component {

    constructor(props){
        super(props)
        this.id = id++;
    }

    state = {
        show: false
    }

    componentDidMount() {
        if(this.props.value){
            for(let i=0;i<this.select.childNodes.length;i++){
                let option = this.select.childNodes[i];
                if(option.value===this.props.value) {
                    this.select.selectedIndex = i;
                    break;
                }
            }
        }
        window.addEventListener("click", this.clickOutside);
        this.options.addEventListener('transitionend', this.transitionEndHandler);
    }

    componentWillUnmount() {
        window.removeEventListener("click", this.clickOutside);
        this.options.removeEventListener('transitionend', this.transitionEndHandler);
    }

    transitionEndHandler=(e)=>{
        if (e.target === this.options) {
            if (this.state.show) this.options.classList.add("ready");
            else this.options.classList.remove("ready");
        }
    }

    clickOutside = (e) => {
        if(e.target!==this.containerSelect) this.setState({ show: false })
    }

    optionHandler = (target) => {
        this.select.selectedIndex = target.props.i;
        this.select.dispatchEvent(new Event('change', { bubbles: true }));
        // this.setState({ show: false })
    }

    onChangeHandler=(e)=>{
        this.setState({value: e.target.value})
        if(this.props.onChange) this.props.onChange(e);
    }

    render() {
        return (
            <div className={`custom-select ${this.props.className} ${this.state.show ? "show" : ""}`} style={this.props.style || null}>
                <div ref={el => (this.containerSelect = el)} className="select" onClick={() => { if (!this.state.show) this.options.scrollTo(0, 0); this.setState({ show: !this.state.show }); }}>
                    <select ref={el => (this.select = el)} onChange={this.onChangeHandler}>
                        {
                            this.props.children ?
                                Children.map(this.props.children, (option, i) => {
                                    return option ? <option key={`option-${this.id}-${i}`} value={option.props.value} hidden={option.props.hidden}>{option.props.label ? option.props.label : option.props.children}</option> : null
                                }): null
                        }
                    </select>
                </div>
                <div className="options" ref={el => (this.options = el)}>
                    <div className="container">
                        {
                            this.props.children ?
                            Children.map(this.props.children, (option, i) => {
                                return option ? option.props.hidden ? null : cloneElement(option, { onClick: this.optionHandler, key: `option-${this.id}-${i}-2`, i: i }) : null;
                            }) : null
                        }
                    </div>
                </div>
            </div>
        )
    }
}

export default Select;